/** What each write mode permits, in one wording.
 *
 * There were two, worded differently — this table, and an inline ternary chain
 * on the run page saying the same three things in other words. The two are the
 * only place an operator is told what a live run may do to their repository,
 * and they must not drift into disagreeing about it.
 */
export const MODE_MEANING: Record<string, string> = {
  observe: "diagnoses and records; never writes to the repository",
  propose: "opens an issue carrying the diagnosis; never pushes",
  push: "pushes a branch and opens a change request",
};

// Deliberately a .ts module, not a .tsx one: it holds no JSX, and keeping it
// out of the two view files is the whole point — they are the only place an
// operator is told what a live run may do to their repository.
